// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Checkbox,
//   Select,
//   MenuItem,
//   TextField,
//   Button,
//   Paper,
//   Box,
//   FormControl,
//   InputLabel,
//   Typography,
//   CircularProgress,
//   TablePagination,
// } from "@mui/material";
// import axios from "axios";
// import Navbar from "../../Navbar";
// import Sidebar from "../../Sidebar";
// import TableContainer from "@mui/material/TableContainer";
// import Autocomplete from "@mui/material/Autocomplete";

// const Branchcaller = () => {
//   const { API_CONFIG } = require("../../../configuration");

//   const [data, setData] = useState([]);
//   const [columns, setColumns] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [branches, setBranches] = useState([]);
//   const [questions, setQuestions] = useState([]);
//   const [sheetList, setSheetList] = useState([]);
//   const [selectedSheet, setSelectedSheet] = useState("");
//   const [searchText, setSearchText] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(8);

//   // const branchList = ["Vijayawada", "Guntur", "Hyderabad"];
//   const callStatusList = [
//     "Attempted - Connected",
//     "Attempted - Not Connected",
//     "Not Attempted",
//   ];
//   const hiddenColumns = [
//     "id",
//     "tele_caller",
//     "region",
//     "area",
//     "branch",
//     // "call_status",
//     // "assign_to",
//     // "case_status",
//     "assign_to_role",
//     "action_type",
//     "action_created_at",
//   ];

//   const customerColumns = [
//     "customer_id",
//     "loan_id",
//     "customer_name",
//     "mobile_number1",
//     "mobile_number2",
//     "date_of_data",
//     // "action_created_at"
//   ];

//   const editableFields = ["remarks1", "remarks2", "remarks3"];
//   const questionColumns = columns.filter(
//     (col) =>
//       !hiddenColumns.includes(col) &&
//       !customerColumns.includes(col) &&
//       !editableFields.includes(col),
//   );
//   const displayColumns = [
//     ...customerColumns,
//     "action_created_at",
//     ...questionColumns,
//      "call_status",
//   "assign_to",
//   "case_status",
//     "remarks1",
//     "remarks2",
//     "remarks3",
//   ];
//   const columnLabels = {
//     customer_id: "CUSTOMER ID",
//     loan_id: "LOAN ID",
//     customer_name: "CUSTOMER NAME",
//     mobile_number1: "MOBILE NUMBER1",
//     mobile_number2: "MOBILE NUMBER2",
//     date_of_data: "DATE OF DATA",
//     action_created_at: "ASSIGNED DATE",

//     remarks1: "REMARKS 1",
//     remarks2: "REMARKS 2",
//     remarks3: "REMARKS 3",
//   };
//   const filteredData = data.filter((row) => {
//     if (!searchText.trim()) return true;

//     const search = searchText.toLowerCase();

//     return displayColumns.some((col) => {
//       const value = row[col];

//       return (
//         value !== null &&
//         value !== undefined &&
//         String(value).toLowerCase().includes(search)
//       );
//     });
//   });
//   const caseStatusList = [
//     "Open",
//     "Action Required",
//     "Closed",
//     "Hold",
//     "No Action Required",
//   ];
//   // =========================
//   // LOAD SHEETS
//   // =========================
//   useEffect(() => {
//     fetchSheets();
//     fetchBranches();
//   }, []);

//   const fetchSheets = async () => {
//     try {
//       const token = localStorage.getItem("token");

//       const res = await axios.get(`${API_CONFIG.APIURL}/call/track/sheets`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setSheetList(res.data || []);
//     } catch (err) {
//       console.error("Sheet Fetch Error:", err);
//     }
//   };
//   const fetchBranches = async () => {
//     try {
//       const token = localStorage.getItem("token");

//       const res = await axios.get(`${API_CONFIG.APIURL}/employee/branches`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       console.log("branches: ", res.data.data);

//       setBranches(res.data.data || []);
//     } catch (error) {
//       console.error("Error fetching branches:", error);
//     }
//   };

//   // =========================
//   // LOAD CUSTOMERS
//   // =========================
//   const fetchCustomers = async (sheetId) => {
//     if (!sheetId) return;

//     try {
//       setLoading(true);
//       setSelectedRows([]);

//       const token = localStorage.getItem("token");
//       const user = JSON.parse(localStorage.getItem("user"));
//       const branch = user?.branch;

//       const res = await axios.get(
//         `${API_CONFIG.APIURL}/brchcaller/customers/${sheetId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//           params: {
//             branch,
//           },
//         },
//       );

//       const result = res.data?.data || [];

//       const cleaned = result.map((row) => ({
//         ...row,
//         id: String(row.id),
//       }));

//       setData(cleaned);
//       setQuestions(res.data.questions || []);

//       if (cleaned.length > 0) {
//         setColumns(Object.keys(cleaned[0]));
//       } else {
//         setColumns([]);
//       }

//       setPage(0);
//     } catch (err) {
//       console.error("Customer Fetch Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // =========================
//   // SELECT ROW
//   // =========================
//   const handleSelect = (id) => {
//     setSelectedRows((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
//     );
//   };

//   // =========================
//   // HANDLE EDIT
//   // =========================
//   const handleChange = (id, field, value) => {
//     setData((prev) =>
//       prev.map((row) => (row.id === id ? { ...row, [field]: value } : row)),
//     );
//   };

//   // =========================
//   // BULK UPDATE
//   // =========================
//   const handleBulkUpdate = async () => {
//     try {
//       setSaving(true);
//       const questionMap = {};

//       questions.forEach((q) => {
//         questionMap[q.question_text] = q.id;
//       });
//       const user = JSON.parse(localStorage.getItem("user") || "{}");
//       const emp_id = user.emp_id;

//       const payload = data
//         .filter((row) => selectedRows.includes(row.id))
//         .map((row) => {
//           const answers = [];

//           questionColumns.forEach((column) => {
//             answers.push({
//               question_id: questionMap[column],
//               answer: row[column] || "",
//             });
//           });

//           return {
//             customer_id: row.id,
//             sheet_id: selectedSheet,
//             emp_id,
//             call_status: row.call_status,
//             remarks1: row.remarks1,
//             remarks2: row.remarks2,
//             remarks3: row.remarks3,
//             assign_to: row.assign_to,
//             case_status: row.case_status,

//             answers,
//           };
//         });
//       console.log("update payload: ", payload);

//       await axios.post(`${API_CONFIG.APIURL}/telecaller/bulk-update`, payload, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });

//       alert("Updated Successfully");

//       setSelectedRows([]);
//       fetchCustomers(selectedSheet);
//     } catch (err) {
//       console.error(err);
//       alert("Update Failed");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // =========================
//   // CELL RENDERER
//   // =========================
//   const renderCell = (row, col) => {
//     const isRowSelected = selectedRows.includes(row.id);

//     if (questionColumns.includes(col)) {
//       return (
//         <Typography
//           sx={{
//             minWidth: 120,
//             fontSize: 14,
//             whiteSpace: "nowrap",
//           }}
//         >
//           {row[col] || "-"}
//         </Typography>
//       );
//     }

//     if (col === "remarks1" || col === "remarks2" || col === "remarks3") {
//       return (
//         <TextField
//           size="small"
//           fullWidth
//           disabled={!isRowSelected}
//           value={row[col] || ""}
//           onChange={(e) => handleChange(row.id, col, e.target.value)}
//           sx={{
//             backgroundColor: !isRowSelected ? "#f5f5f5" : "#fff",
//           }}
//         />
//       );
//     }

//     return (
//       <Typography
//         sx={{
//           minWidth: 120,
//           fontSize: 14,
//           fontWeight: 500,
//           whiteSpace: "nowrap",
//         }}
//       >
//         {row[col] || "-"}
//       </Typography>
//     );
//   };
//   // =========================
//   // UI
//   // =========================
//   return (
//     <Box sx={{ display: "flex", width: "100%", overflow: "hidden" }}>
//       <Sidebar />

//       <Box sx={{ flex: 1, minWidth: 0 }}>
//         <Navbar />

//         <Paper sx={{ m: 2, p: 2 }}>
//           <Typography variant="h6" sx={{ mb: 2 }}>
//             Branchcaller Sheet Report
//           </Typography>

//           {/* ACTIONS */}
//           <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
//             <FormControl size="small" sx={{ minWidth: 280 }}>
//               <InputLabel>Select Calling Sheet</InputLabel>

//               <Select
//                 value={selectedSheet}
//                 label="Select Calling Sheet"
//                 displayEmpty
//                 onChange={(e) => {
//                   setSelectedSheet(e.target.value);
//                   fetchCustomers(e.target.value);
//                 }}
//               >
//                 {/* <MenuItem value="">
//                   <em>Choose a Sheet</em>
//                 </MenuItem> */}

//                 {sheetList.map((sheet) => (
//                   <MenuItem key={sheet.id} value={sheet.id}>
//                     {sheet.sheet_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <TextField
//               size="small"
//               label="Search Customer / Mobile / Loan / Branch..."
//               value={searchText}
//               onChange={(e) => setSearchText(e.target.value)}
//               sx={{ minWidth: 350 }}
//             />
//             <Button
//               variant="outlined"
//               onClick={() => fetchCustomers(selectedSheet)}
//             >
//               Refresh
//             </Button>

//             <Button
//               variant="contained"
//               disabled={selectedRows.length === 0 || saving}
//               onClick={handleBulkUpdate}
//             >
//               {saving
//                 ? "Updating..."
//                 : `Update Selected (${selectedRows.length})`}
//             </Button>
//           </Box>

//           {/* LOADING */}
//           {loading ? (
//             <Box sx={{ textAlign: "center", p: 4 }}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             <>
//               {/* <Box sx={{ overflow: "auto", maxWidth: "100%" }}> */}
//               <TableContainer
//                 sx={{
//                   maxHeight: "65vh",
//                   overflow: "auto",
//                   border: "1px solid #e5e7eb",
//                   borderRadius: 2,
//                   "&::-webkit-scrollbar": {
//                     height: 8,
//                     width: 8,
//                   },
//                   "&::-webkit-scrollbar-thumb": {
//                     backgroundColor: "#cbd5e1",
//                     borderRadius: 10,
//                   },
//                 }}
//               >
//                 <Table
//                   stickyHeader
//                   size="small"
//                   sx={{
//                     minWidth: "max-content",
//                     tableLayout: "auto",
//                   }}
//                 >
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>Select</TableCell>

//                       {/* {displayColumns.map((col) => (
//                         <TableCell
//                           key={col}
//                           sx={{
//                             fontWeight: 700,
//                             minWidth: 180,
//                             backgroundColor: "#f5f7fa",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {col.replaceAll("_", " ").toUpperCase()}
//                         </TableCell>
//                       ))} */}
//                       {displayColumns.map((column) => (
//                         <TableCell
//                           sx={{
//                             fontWeight: 700,
//                             minWidth: 180,
//                             backgroundColor: "#f5f7fa",
//                             whiteSpace: "nowrap",
//                           }}
//                           key={column}
//                         >
//                           {columnLabels[column] || column}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   </TableHead>

//                   <TableBody>
//                     {filteredData
//                       // .slice(
//                       //   page * rowsPerPage,
//                       //   page * rowsPerPage + rowsPerPage,
//                       // )
//                       .map((row) => (
//                         <TableRow
//                           key={row.id}
//                           hover
//                           selected={selectedRows.includes(row.id)}
//                           sx={{
//                             backgroundColor: selectedRows.includes(row.id)
//                               ? "#E3F2FD"
//                               : "inherit",
//                           }}
//                         >
//                           <TableCell>
//                             <Checkbox
//                               checked={selectedRows.includes(row.id)}
//                               onChange={() => handleSelect(row.id)}
//                             />
//                           </TableCell>

//                           {displayColumns.map((col) => (
//                             <TableCell key={col}>
//                               {renderCell(row, col)}
//                             </TableCell>
//                           ))}
//                         </TableRow>
//                       ))}
//                   </TableBody>
//                 </Table>
//                 {/* </Box> */}
//               </TableContainer>

//               {/* PAGINATION */}
//               <TablePagination
//                 component="div"
//                 count={filteredData.length}
//                 page={page}
//                 rowsPerPage={rowsPerPage}
//                 onPageChange={(event, newPage) => {
//                   setPage(newPage);
//                 }}
//                 onRowsPerPageChange={(event) => {
//                   setRowsPerPage(+event.target.value);
//                   setPage(0);
//                 }}
//                 rowsPerPageOptions={[8, 15, 25, 50]}
//                 showFirstButton
//                 showLastButton
//               />
//             </>
//           )}
//         </Paper>
//       </Box>
//     </Box>
//   );
// };

// export default Branchcaller;

import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Select,
  MenuItem,
  TextField,
  Button,
  Paper,
  Box,
  FormControl,
  InputLabel,
  Typography,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import axios from "axios";
import Navbar from "../../Navbar";
import Sidebar from "../../Sidebar";
import TableContainer from "@mui/material/TableContainer";
import Autocomplete from "@mui/material/Autocomplete";

import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";

const Branchcaller = () => {
  const { API_CONFIG } = require("../../../configuration");

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [branches, setBranches] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [sheetList, setSheetList] = useState([]);
  const [selectedSheet, setSelectedSheet] = useState("");
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [openDialog, setOpenDialog] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [remarks1, setRemarks1] = useState("");

  // const branchList = ["Vijayawada", "Guntur", "Hyderabad"];
  const callStatusList = [
    "Attempted - Connected",
    "Attempted - Not Connected",
    "Not Attempted",
  ];
  const hiddenColumns = [
    "id",
    "tele_caller",
    "assign_to_role",
    "action_type",
    "action_created_at",
    "audit_trail",
  ];

  const customerColumns = [
    "region",
    "area",
    "branch",
    "customer_id",
    "loan_id",
    "customer_name",
    "mobile_number1",
    "mobile_number2",
    "date_of_data",
  ];

  const editableFields = [
    "remarks1",
    "remarks2",
    "remarks3",
    "assign_to",
    "case_status",
    "call_status",
  ];
  const readonlyFields = [
    "region",
    "area",
    "branch",
    "customer_id",
    "loan_id",
    "customer_name",
    "date_of_data",
    "mobile_number1",
    "mobile_number2",
  ];
  const questionColumns = columns.filter(
    (col) =>
      !hiddenColumns.includes(col) &&
      !customerColumns.includes(col) &&
      !editableFields.includes(col),
  );
  const displayColumns = [
    ...customerColumns,
    // "mobile_number1",
    // "mobile_number2",
    // ...questionColumns,
    // "call_status",
    // "remarks1",
    // "remarks2",
    // "remarks3",
    // "assign_to",
    // "case_status",
  ];
  const filteredData = data.filter((row) => {
    if (!searchText.trim()) return true;

    const search = searchText.toLowerCase();

    return displayColumns.some((col) => {
      const value = row[col];

      return (
        value !== null &&
        value !== undefined &&
        String(value).toLowerCase().includes(search)
      );
    });
  });
  const caseStatusList = [
    "Open",
    "Action Required",
    "Closed",
    "Hold",
    "No Action Required",
  ];

  const customerInfoFields = [
    { label: "Region", key: "region" },
    { label: "Area", key: "area" },
    { label: "Branch", key: "branch" },
    { label: "Tele Caller", key: "tele_caller" },
    { label: "Customer Id", key: "customer_id" },
    { label: "Customer Name", key: "customer_name" },
    { label: "Loan Id", key: "loan_id" },
    { label: "Date Of Data", key: "date_of_data" },
    { label: "Mobile Number 1", key: "mobile_number1" },
    { label: "Mobile Number 2", key: "mobile_number2" },
  ];

  const handleOpenDialog = (row) => {
    setEditRow(row);
    setRemarks1(""); // always empty
    setOpenDialog(true);
  };
  // =========================
  // LOAD SHEETS
  // =========================
  useEffect(() => {
    fetchSheets();
    fetchBranches();
  }, []);

  const fetchSheets = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API_CONFIG.APIURL}/call/track/sheets`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setSheetList(res.data || []);
    } catch (err) {
      console.error("Sheet Fetch Error:", err);
    }
  };
  const fetchBranches = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API_CONFIG.APIURL}/employee/branches`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log("branches: ", res.data.data);

      setBranches(res.data.data || []);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  // =========================
  // LOAD CUSTOMERS
  // =========================
  const fetchCustomers = async (sheetId) => {
    if (!sheetId) return;

    try {
      setLoading(true);
      setSelectedRows([]);

      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      const branch = user?.branch;

      const res = await axios.get(
        `${API_CONFIG.APIURL}/brchcaller/customers/${sheetId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            branch,
          },
        },
      );

      const result = res.data?.data || [];

      const cleaned = result.map((row) => ({
        ...row,
        id: String(row.id),
      }));

      setData(cleaned);
      setQuestions(res.data.questions || []);

      if (cleaned.length > 0) {
        setColumns(Object.keys(cleaned[0]));
      } else {
        setColumns([]);
      }

      setPage(0);
    } catch (err) {
      console.error("Customer Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // SELECT ROW
  // =========================
  // const handleSelect = (id) => {
  //   setSelectedRows((prev) =>
  //     prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
  //   );
  // };

  // =========================
  // HANDLE EDIT
  // =========================
  const handleChange = (id, field, value) => {
    setData((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row)),
    );
  };

  const handleEditClick = (row) => {
    setEditRow({ ...row });
    setOpenDialog(true);
  };

  const handleDialogChange = (field, value) => {
    setEditRow((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // =========================
  // BULK UPDATE
  // =========================
  const handleUpdateRecord = async () => {
    try {
      setSaving(true);

      const questionMap = {};

      questions.forEach((q) => {
        questionMap[q.question_text] = q.id;
      });

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      const answers = [];

      questionColumns.forEach((column) => {
        answers.push({
          question_id: questionMap[column],
          answer: editRow[column] || "",
        });
      });

      const payload = [
        {
          customer_id: editRow.id,
          sheet_id: selectedSheet,
          emp_id: user.emp_id,
          tele_caller: editRow.tele_caller,
          mobile_number1: editRow.mobile_number1,
          mobile_number2: editRow.mobile_number2,

          call_status: editRow.call_status,
          remarks1: editRow.remarks1,
          remarks2: editRow.remarks2,
          remarks3: editRow.remarks3,
          assign_to: editRow.assign_to,
          case_status: editRow.case_status,

          answers,
        },
      ];
      // console.log("Update Payload:", payload);

      await axios.post(`${API_CONFIG.APIURL}/brchcaller/bulk-update`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      alert("Record Updated Successfully");

      setOpenDialog(false);

      fetchCustomers(selectedSheet);
    } catch (error) {
      console.error(error);
      alert("Update Failed");
    } finally {
      setSaving(false);
    }
  };

  // =========================
  // CELL RENDERER
  // =========================
  const renderCell = (row, col) => {
    const isRowSelected = selectedRows.includes(row.id);

    if (questionColumns.includes(col)) {
      return (
        <TextField
          size="small"
          fullWidth
          disabled={!isRowSelected}
          value={row[col] || ""}
          onChange={(e) => handleChange(row.id, col, e.target.value)}
          sx={{
            backgroundColor: !isRowSelected ? "#f5f5f5" : "#fff",
          }}
        />
      );
    }

    if (col === "call_status") {
      return (
        <Select
          size="small"
          fullWidth
          disabled={!isRowSelected}
          value={row[col] || ""}
          onChange={(e) => handleChange(row.id, col, e.target.value)}
        >
          {callStatusList.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      );
    }

    if (col === "remarks1" || col === "remarks2" || col === "remarks3") {
      return (
        <TextField
          size="small"
          fullWidth
          disabled={!isRowSelected}
          value={row[col] || ""}
          onChange={(e) => handleChange(row.id, col, e.target.value)}
          sx={{
            backgroundColor: !isRowSelected ? "#f5f5f5" : "#fff",
          }}
        />
      );
    }

    if (col === "assign_to") {
      return (
        <Autocomplete
          size="small"
          disabled={!isRowSelected}
          options={branches || []}
          getOptionLabel={(option) =>
            `${option.branch_id} - ${option.branch_name}`
          }
          value={branches.find((b) => b.branch_id === row.assign_to) || null}
          onChange={(event, newValue) => {
            handleChange(row.id, "assign_to", newValue?.branch_id || "");
          }}
          renderInput={(params) => (
            <TextField {...params} size="small" placeholder="Search Branch" />
          )}
          renderOption={(props, option) => (
            <li {...props}>
              {option.branch_id} - {option.branch_name}
            </li>
          )}
        />
      );
    }

    if (col === "case_status") {
      return (
        <Select
          size="small"
          fullWidth
          disabled={!isRowSelected}
          value={row[col] || ""}
          onChange={(e) => handleChange(row.id, col, e.target.value)}
        >
          {caseStatusList.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      );
    }

    return (
      <Typography
        sx={{
          minWidth: 120,
          fontSize: 14,
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
        {row[col] || "-"}
      </Typography>
    );
  };
  // =========================
  // UI
  // =========================
  return (
    <>
      <Navbar />
      <Sidebar />

      <Box
        sx={{
          p: { xs: 1.5, sm: 2, md: 3 },
          ml: { xs: 0, md: "250px" },
          width: {
            xs: "100%",
            md: "calc(100% - 250px)",
          },
          boxSizing: "border-box",
          overflowX: "hidden",
          backgroundColor: "#F9FAFB",
          minHeight: "100vh",
        }}
      >
        <Paper sx={{ m: 2, p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Branchcaller Sheet Report
          </Typography>

          {/* ACTIONS */}
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 280 }}>
              <InputLabel>Select Calling Sheet</InputLabel>

              <Select
                value={selectedSheet}
                label="Select Calling Sheet"
                displayEmpty
                onChange={(e) => {
                  setSelectedSheet(e.target.value);
                  fetchCustomers(e.target.value);
                }}
              >
                {/* <MenuItem value="">
                  <em>Choose a Sheet</em>
                </MenuItem> */}

                {sheetList.map((sheet) => (
                  <MenuItem key={sheet.id} value={sheet.id}>
                    {sheet.sheet_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              size="small"
              label="Search Customer / Mobile / Loan / Branch..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={{ minWidth: 350 }}
            />
            <Button
              variant="outlined"
              onClick={() => fetchCustomers(selectedSheet)}
            >
              Refresh
            </Button>

            {/* <Button
              variant="contained"
              disabled={selectedRows.length === 0 || saving}
              onClick={handleBulkUpdate}
            >
              {saving
                ? "Updating..."
                : `Update Selected (${selectedRows.length})`}
            </Button> */}
          </Box>

          {/* LOADING */}
          {loading ? (
            <Box sx={{ textAlign: "center", p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {/* <Box sx={{ overflow: "auto", maxWidth: "100%" }}> */}
              <TableContainer
                sx={{
                  maxHeight: "65vh",
                  overflow: "auto",
                  border: "1px solid #e5e7eb",
                  borderRadius: 2,
                  "&::-webkit-scrollbar": {
                    height: 8,
                    width: 8,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#cbd5e1",
                    borderRadius: 10,
                  },
                }}
              >
                <Table
                  stickyHeader
                  size="small"
                  sx={{
                    minWidth: "max-content",
                    tableLayout: "auto",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Edit</TableCell>

                      {displayColumns.map((col) => (
                        <TableCell
                          key={col}
                          sx={{
                            fontWeight: 700,
                            minWidth: 180,
                            backgroundColor: "#f5f7fa",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {col.replaceAll("_", " ").toUpperCase()}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {filteredData
                      // .slice(
                      //   page * rowsPerPage,
                      //   page * rowsPerPage + rowsPerPage,
                      // )
                      .map((row) => (
                        <TableRow
                          key={row.id}
                          hover
                          selected={selectedRows.includes(row.id)}
                          sx={{
                            backgroundColor: selectedRows.includes(row.id)
                              ? "#E3F2FD"
                              : "inherit",
                          }}
                        >
                          <TableCell>
                            <IconButton
                              color="primary"
                              onClick={() => handleEditClick(row)}
                            >
                              <EditIcon />
                            </IconButton>
                          </TableCell>

                          {displayColumns.map((col) => (
                            <TableCell key={col}>
                              {renderCell(row, col)}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                {/* </Box> */}
              </TableContainer>

              {/* PAGINATION */}
              <TablePagination
                component="div"
                count={filteredData.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={(event, newPage) => {
                  setPage(newPage);
                }}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(+event.target.value);
                  setPage(0);
                }}
                rowsPerPageOptions={[8, 15, 25, 50]}
                showFirstButton
                showLastButton
              />
            </>
          )}
        </Paper>
      </Box>
      <Dialog
        open={openDialog}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            height: "90vh",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          Customer Details
        </DialogTitle>

        <DialogContent
          sx={{
            p: 0,
            flex: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {editRow && (
            <>
              {/* FIXED HEADER */}
              <Box
                sx={{
                  p: 2,
                  bgcolor: "#fff",
                  borderBottom: "1px solid #e5e7eb",
                  flexShrink: 0,
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "1fr 1fr",
                      md: "1fr 1fr 1fr",
                      lg: "1fr 1fr 1fr 1fr",
                    },
                    gap: 1,
                  }}
                >
                  {customerInfoFields.map((field) => (
                    <Box
                      key={field.key}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        // py: 0.75,
                        px: 1,
                        borderBottom: "1px dashed #e2e8f0",
                        minHeight: 25,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#64748b",
                          minWidth: 110,
                          flexShrink: 0,
                        }}
                      >
                        {field.label}:
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "#0f172a",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {editRow[field.key] || "-"}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>

              <Box
                sx={{
                  flex: 1,
                  overflowY: "auto",
                  p: 2,
                  minHeight: 0,
                }}
              >
                <Grid
                  container
                  spacing={2}
                  sx={{
                    flex: 1,
                    minHeight: 0,
                  }}
                >
                  {/* LEFT SIDE */}
                  <Grid item xs={12} md={8}>
                    <Box
                      sx={{
                        height: "100%",
                        overflowY: "auto",
                        border: "1px solid #d1d5db",
                        borderRadius: 2,
                        p: 2,
                        bgcolor: "#fff",
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 700,
                          mb: 2,
                          color: "#1976d2",
                        }}
                      >
                        Questions
                      </Typography>

                      {questionColumns.map((question, index) => (
                        <Box
                          key={question}
                          sx={{
                            pb: 2,
                            borderBottom:
                              index !== questionColumns.length - 1
                                ? "1px solid #e5e7eb"
                                : "none",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                              // mb: 1,
                            }}
                          >
                            {question}
                          </Typography>

                          <Box
                            sx={{
                              p: 1.5,
                              border: "1px solid #e5e7eb",
                              borderRadius: 1,
                              backgroundColor: "#f8fafc",
                              minHeight: 20,
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            {editRow[question] || "-"}
                          </Box>
                        </Box>
                      ))}

                      {/* Call Status */}
                      <TextField
                        fullWidth
                        size="small"
                        label="Call Status"
                        value={editRow.call_status || "-"}
                        InputProps={{
                          readOnly: true,
                        }}
                        sx={{
                          mt: 2,
                          "& .MuiInputBase-root": {
                            backgroundColor: "#f8fafc",
                          },
                        }}
                      />

                      {/* Case Status */}
                      <TextField
                        fullWidth
                        size="small"
                        label="Case Status"
                        value={editRow.case_status || "-"}
                        InputProps={{
                          readOnly: true,
                        }}
                        sx={{
                          mt: 2,
                          "& .MuiInputBase-root": {
                            backgroundColor: "#f8fafc",
                          },
                        }}
                      />

                      {/* Assign To */}
                      <TextField
                        fullWidth
                        size="small"
                        label="Assigned To"
                        value={editRow.tele_caller || "-"}
                        InputProps={{
                          readOnly: true,
                        }}
                        sx={{
                          mt: 2,
                          "& .MuiInputBase-root": {
                            backgroundColor: "#f8fafc",
                          },
                        }}
                      />

                      {/* Remarks */}
                      {/* <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="Remarks 1"
                        sx={{ mt: 2 }}
                        value={editRow.remarks1 || ""}
                        onChange={(e) =>
                          handleDialogChange("remarks1", e.target.value)
                        }
                      /> */}
                      <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="Remarks 1"
                        sx={{ mt: 2 }}
                        value={remarks1}
                        onChange={(e) => {
                          setRemarks1(e.target.value);
                          handleDialogChange("remarks1", e.target.value);
                        }}
                      />
                    </Box>
                  </Grid>

                  {/* RIGHT SIDE */}
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid #d1d5db",
                        borderRadius: 2,
                        bgcolor: "#fff",
                      }}
                    >
                      <Box
                        sx={{
                          p: 2,
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: "#ef6c00",
                          }}
                        >
                          Remarks Audit Trail
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          flex: 1,
                          overflowY: "auto",
                          p: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            whiteSpace: "pre-wrap",
                            fontSize: 13,
                          }}
                        >
                          {editRow?.audit_trail || "-"}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            borderTop: "1px solid #e5e7eb",
            px: 3,
            py: 2,
            flexShrink: 0,
            bgcolor: "#fff",
          }}
        >
          <Button color="inherit" onClick={() => setOpenDialog(false)}>
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleUpdateRecord}
            disabled={saving}
          >
            {saving ? "Updating..." : "Update"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Branchcaller;
